import React from 'react';
import cx from 'classnames';
import moment from 'moment';
import 'moment-timezone';
import { containsHtml, newLinesToHtml, sanitizeHtml, markdownToHtml } from '../../utils/html.utils';

const AIAssistantChatHistory = ({ chatHistory }) => {
  const todayMoment = moment();
  const dailyHistory = {};
  
  for (const historyItem of chatHistory) {
    const date = moment(historyItem.time).startOf('day').format();
    
    if (!dailyHistory[date]) {
      dailyHistory[date] = [];
    }
  
    dailyHistory[date].push(historyItem);
  }
  
  const dailyEntries = Object.entries(dailyHistory);
  const lastDailyIndex = dailyEntries.length - 1;
  const lastDailyItemIndex = dailyEntries[lastDailyIndex][1].length - 1;
  let animationDelay = 400;
  
  return (
    <div className="ai-assistant-chat-history">
      {dailyEntries.map((dailyEntry, dailyIndex) => {
        const [date, items] = dailyEntry;
        const msgMoment = moment(date);
        const dateStr = msgMoment.isSame(todayMoment, 'day') ? 'Today' : msgMoment.format('MMMM DD');
        const isLastDay = lastDailyIndex === dailyIndex;
        
        return (
          <div key={date} className="ai-assistant-chat-history-day">
            <div className="ai-assistant-chat-history-date">
              <div>{dateStr}</div>
            </div>
            
            <div className="ai-assistant-chat-history-items">
              {items.map((item, itemIndex) => {
                const isLastItem = lastDailyItemIndex === itemIndex;
                const msgAnimationDelay = animationDelay;
                const isUser = item.type === 'user';
                const isBot = item.type === 'bot';
                let textContent = '';
                let htmlContent = '';
                animationDelay += 20;
                
                if (isUser) {
                  textContent = sanitizeHtml(newLinesToHtml(item.text));
                } else if (isBot) {
                  const text = !containsHtml(item.text) ? markdownToHtml(item.text) : newLinesToHtml(item.text);
                  
                  textContent = sanitizeHtml(text);
                  htmlContent = sanitizeHtml(item.html);
                }
    
                return (
                  <div
                    key={item.id}
                    style={{ animationDelay: `${msgAnimationDelay}ms` }}
                    data-animation-delay={isLastDay && isLastItem ? msgAnimationDelay : undefined}
                    className={cx('ai-assistant-msg', {
                      'ai-assistant-msg-user': isUser,
                      'ai-assistant-msg-bot': isBot,
                    })}
                  >
                    <div className="ai-assistant-msg-content">
                      {textContent ? (
                        <div
                          className={cx('ai-assistant-msg-text', {
                            'ai-assistant-msg-text-markdown': isBot,
                            'markdown-container': isBot,
                          })}
                          dangerouslySetInnerHTML={{ __html: textContent }}
                        />
                      ) : null}
                      
                      {htmlContent ? (
                        <div
                          className="ai-assistant-msg-text ai-assistant-msg-text-html"
                          dangerouslySetInnerHTML={{ __html: htmlContent }}
                        />
                      ) : null}
          
                      <div className="ai-assistant-msg-time">
                        {moment(item.time).format('LT')}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AIAssistantChatHistory;
